import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Dashboard({ userId }) {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBalance();
  }, [userId]);

  const fetchBalance = async () => {
    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await api.getBalance(userId);
      setBalance(response.balance || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refreshBalance = () => {
    fetchBalance();
  };

  return (
    <div className="balance-card">
      <div className="balance-label">Centro Balance</div>
      {loading ? (
        <div className="loading">Loading balance...</div>
      ) : error ? (
        <div className="alert alert-error">{error}</div>
      ) : (
        <>
          <div className="balance-amount">{balance.toLocaleString()} Centro</div>
          <button onClick={refreshBalance} className="btn btn-secondary" style={{ marginTop: '15px' }}>
            Refresh Balance
          </button>
        </>
      )}
    </div>
  );
}

export default Dashboard;
